<template>
  <div class="center detail" v-bind:class="{'desktop-listing':!isMobile, 'mobile-listing':isMobile}">
    <v-container fluid grid-list-md>
      <v-flex v-bind="{ [`${flex}`]: false }">
        <v-layout column>
          <v-card flat>
            <v-card-title><h4>{{ property.title }}</h4></v-card-title>
            <v-card-title v-if="property.soldDate"><span class="label">Sold Date:</span><span class="value">{{ property.soldDate }}</span></v-card-title>
            <v-card-title v-if="property.sold"><span class="label">Sold Price:</span><span class="value">{{ formatPrice(property.soldPrice) }}</span></v-card-title>
            <v-card-title v-else><span class="label">Listing Price:</span><span class="value">{{ formatPrice(property.price) }}</span>
              <v-btn small light flat @click="calculate(property.price)"><v-icon small color="grey darken-1">fas fa-calculator</v-icon>&nbsp;<span class="link">Mortgage Calculator</span></v-btn>
            </v-card-title>
            <v-card-title><span class="label">Living Area:</span><span class="value">{{ property.livingArea }} Sq. Ft.</span></v-card-title>
            <v-card-title><span class="label">Lot Size:</span><span class="value">{{ property.lotSize?(property.lotSize +' Sq. Ft.'):(property.lotSizeAcre?(property.lotSizeAcre+' Acres'):'') }}</span></v-card-title>
            <v-card-title><span class="label">Bedrooms:</span><span class="value">{{ property.bedroom }}</span> </v-card-title>
            <v-card-title><span class="label">Bathrooms:</span><span class="value">{{ property.bathroom }}</span> </v-card-title>
            <v-card-title><span class="label">Year Build:</span><span class="value">{{ property.yearBuild }}</span> </v-card-title>
            <v-data-iterator v-if="property.picsWithTitle" :items="property.picsWithTitle" hideActions content-tag="v-layout" row wrap>
              <v-flex slot="item" slot-scope="props">
                <div class="img-container">
                  <div class="pic-title-bg"><div class="pic-title">{{ props.item.title }}</div></div>
                  <v-img :lazy-src="property.thumb?(imgPath+property.id+'/thumbs/'+props.item.pic):''" :src="imgPath+property.id+'/'+props.item.pic">
                    <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </v-img>
                </div>
              </v-flex>
            </v-data-iterator>
            <v-data-iterator v-else :items="property.pics" hideActions content-tag="v-layout" row wrap>
              <v-flex slot="item" slot-scope="props">
                <div class="img-container">
                  <v-img :lazy-src="property.thumb?(imgPath+property.id+'/thumbs/'+props.item):''" :src="imgPath+property.id+'/'+props.item">
                    <v-layout slot="placeholder" fill-height align-center justify-center ma-0>
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </v-img>
                </div>
              </v-flex>
            </v-data-iterator>
            <!--<div class="center" style="padding-bottom: 15px">-->
              <!--<v-btn class="hint&#45;&#45;text" @click="back">-->
                <!--<span><v-icon color="titleIcon" small>fas fa-chevron-left</v-icon>&nbsp;Back</span>-->
              <!--</v-btn>-->
            <!--</div>-->
            <v-card-text class="back-btn">
              <v-btn small light round @click="back">
                <v-icon small color="pink">fas fa-chevron-left</v-icon>&nbsp;Back
              </v-btn>
            </v-card-text>
            <div class="bottom-space"></div>
          </v-card>
        </v-layout>
      </v-flex>
    </v-container>
    <!--<div style="position: fixed; bottom: 60px; display: flex; background: rgba(104,43,20,0.28);color:white">-->
      <!--<h4>{{ property.title }}</h4>-->
      <!--<span>Listing Price: {{ formatPrice(property.price) }}</span>-->
      <!--<span>Living Area: {{ property.livingArea }} Sq. Ft.</span>-->
      <!--<span>Lot Size: {{ property.lotSize?(property.lotSize +'Sq. Ft.'):'' }}</span>-->
      <!--<span>Bedrooms: {{ property.bedroom }}</span>-->
      <!--<span>Bathrooms: {{ property.bathroom }}</span>-->
      <!--<span>Year Build: {{ property.yearBuild }}</span>-->
    <!--</div>-->
    <!--<div style="position: fixed; bottom: 50px; display: flex; background: rgba(104,43,20,0.28);color:white">-->
      <!--<h4>{{ property.title }}</h4>-->
      <!--<span class="label">Listing Price:</span><span class="value">{{ formatPrice(property.price) }}</span>-->
      <!--<span class="label">Living Area:</span><span class="value">{{ property.livingArea }} Sq. Ft.</span>-->
      <!--<span class="label">Lot Size:</span><span class="value">{{ property.lotSize?(property.lotSize +'Sq. Ft.'):'' }}</span>-->
      <!--<span class="label">Bedrooms:</span><span class="value">{{ property.bedroom }}</span>-->
      <!--<span class="label">Bathrooms:</span><span class="value">{{ property.bathroom }}</span>-->
      <!--<span class="label">Year Build:</span><span class="value">{{ property.yearBuild }}</span>-->
    <!--</div>-->
  </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'
  import {Utils} from '../utils'

    export default {
        name: "detail",
      data(){
        return {
          imgPath: 'http://www.juliazhao.com/realestate/properties/'
        }
      },
      computed: {
        ...mapState({
          isMobile: state => state.homeStore.isMobile,
          property: state => state.homeStore.currentProperty
        }),
        flex: {
          get(){
            if( this.isMobile ) return 'xs12'
            return 'xs6'
          },
          set(val){

          }
        }
      },
      methods: {
        ...mapMutations(['setCalculatePrice']),
        formatPrice: function (price) {
          return Utils.getPriceTxt(price, false)
        },
        back(){
          this.$router.go(-1)
        },
        calculate(price){
          this.setCalculatePrice(price)
          this.$router.push('/calculator')
        }
      }
    }
</script>

<style scoped>
  @import "detail.css";
</style>
